<div class="al-notification-form ui-fluid">
    <div *ngIf="!loading" class="p-grid">
        <div class="p-col-12 form-description" *ngIf="formDescription">
            {{formDescription}}
        </div>
        <div class="p-col-4">
            <!-- Left content column goes here -->
            <ng-content></ng-content>
        </div>
        <div class="p-col-4">
            <div class="p-grid p-dir-col">
                <div class="p-col-12">
                    <h1 class="columnHeader">Recipients</h1>
                </div>
                <span *ngIf="type !== 'search_v2'" class="p-col section-title">
                    Subscribe yourself, other users, or a {{renameConnectors ? 'templated connection' : 'connector'}} to receive this notification.
                </span>
                <span *ngIf="type === 'search_v2'" class="p-col section-title">
                    Subscribe yourself or other users to receive this notification.
                </span>

                <al-menu-list
                    [options]="subscribersMenu"
                    [selectedItem]="selectedItemMenu"
                    (onItemSelected)="onSelectSubcriptionType($event)"></al-menu-list>
            </div>
        </div>
        <div class="p-col-4">
            <div class="p-grid p-dir-col">
                <div class="p-col-12">
                    <h1 class="columnHeader">Notification Delivery</h1>
                </div>
                <div class="p-col-12">
                    <div class="usersDiv" *ngIf="subscriptionType==='users'">
                        <al-multiselect-list
                            placeholder="Select User(s)"
                            name="selectedUsers"
                            [(ngModel)]="selectedUsers"
                            (ngModelChange)="onSelectedUser($event)"
                            class="p-col-12 multiselect-users"
                            [options]="allSelectableUsers"></al-multiselect-list>
                    </div>
                    <div class="usersDiv" *ngIf="subscriptionType==='integrations'">
                        <div class="p-col-12">
                            <p-dropdown
                                name="integration"
                                [options]="allSelectableIntegrations"
                                [(ngModel)]="selectedIntegration"
                                (ngModelChange)="onSelectedIntegration($event)"
                                [placeholder]="renameConnectors ? 'Templated Connection' : 'Select Connector'"
                                showClear="true"
                                class="p-col multiselect-users"></p-dropdown>
                        </div>
                        <div class="p-col-12">
                            <p for="float-input" *ngIf="webhookPayloadFormat || samples">Sample</p>
                            <ng-container *ngIf="samples; then tplSample; else default"></ng-container>
                            <ng-template #tplSample >
                                <ng-container *ngFor="let sample of samples">
                                    <p>{{sample.title}}</p>
                                    <pre *ngIf="sample.type === 'json'">{{ sample.content | json }}</pre>
                                    <p *ngIf="sample.type !== 'json'">{{sample.content}}</p>
                                </ng-container>
                            </ng-template>
                            <ng-template #default>
                                <pre *ngIf="webhookPayloadFormat">{{webhookPayloadFormat | json}}</pre>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div class="p-col" *ngIf="subscriptionType==='users'">
                    <span class="md-inputfield">
                        <input
                            type="text"
                            class="p-col-12"
                            name="emailSubject"
                            [(ngModel)]="emailSubject"
                            (ngModelChange)="onChanged.emit()"
                            pInputText
                            required/>
                        <label for="float-input">Email Subject</label>
                    </span>
                </div>
                <div class="p-col" *ngIf="showAttach">
                    <div class="label-title">Options</div>
                    <span class="md-inputfield">
                        <p-checkbox
                            [(ngModel)]="includeAttachments"
                            (onChange)="onChanged.emit()"
                            binary="true">
                        </p-checkbox>
                        <span class="padding-left-10">Attach File&nbsp;<span class="material-icons" style="font-size: 20px; color: gray; vertical-align: middle" pTooltip="If selected, includes the report as an attachment instead of linking to it">info</span></span>
                    </span>
                    <span class="md-inputfield" *ngIf="type === 'search_v2'">
                        <p-checkbox
                            [(ngModel)]="receiveEmpty"
                            (onChange)="onNotifyBehaviorChanged($event)"
                            binary="true">
                        </p-checkbox>
                        <span class="padding-left-10">Receive a notification even if the scheduled search yields no results</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
